import styled from 'styled-components'
import { media } from '../../../utils'

const checkmark = require('../../../assets/wizard/check.png')

export const Checkmark = styled.div`
  position: absolute;
  left: 15px;
  bottom: 15px;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border: 2px solid #4a4a4a;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70% auto;
  background-image: url(${(props) => props.checked && checkmark});
  cursor: pointer;

  p {
    transform: translate(30px, -1px);
  }

  ${media.desktop`
      margin-bottom: 5px;
      height: 20px;
      width: 20px;
  `}
`
Checkmark.defaultProps = {
  color: 'transparent',
  image: checkmark,
  size: 25
}

export default Checkmark



// WEBPACK FOOTER //
// ./src/components/atoms/input/Checkmark.tsx